<script setup lang="ts">
import AppNavLink from "@/layout/AppNavLink.vue";
import { ref } from "vue";
import { useMenuStore } from "@/stores/menu.ts";

const menuStore = useMenuStore();
const showMenu = ref(false);

function toggleMenu() {
  showMenu.value = !showMenu.value;
}
</script>

<template>
  <a class="xl:hidden block cursor-pointer" @click="toggleMenu">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
    >
      <path d="M0 0H22V4.07145H0V0Z" fill="#3B914D" />
      <path d="M0 7.4644H22V11.5358H0V7.4644Z" fill="#3B914D" />
      <path d="M0 14.9285H22V19H0V14.9285Z" fill="#3B914D" />
    </svg>
  </a>

  <div
    class="absolute right-0 top-full mt-1 bg-grey rounded-[20px] py-5 px-7 flex flex-col gap-2.5 z-10"
    :class="{ hidden: !showMenu }"
    @click="showMenu = false"
  >
    <app-nav-link
      v-for="item in menuStore.header"
      :key="item.title"
      v-bind="item"
      class="text-xl font-bold hover:text-green"
    >
      {{ item.title }}
    </app-nav-link>

    <slot />
  </div>
</template>
